import React from 'react'
import { components } from 'cng-web-lib'

import ProductListEditFormProperties from './CiaPartyConfig_ProductListEditFormProperties'
import CIAPartyConfigApiUrls from 'src/apiUrls/CIAPartyConfigApiUrls'

const { form: {CngEditForm}} = components

function ProductListEditForm({history, showNotification, id, disabled}){
    return(
        //* Start JSX
        <CngEditForm
			fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
			history={history}
			showNotification={showNotification}
			bodySection={
				<ProductListEditFormProperties.Fields
					showNotification={showNotification}
					id={id}
					disabled={disabled}
				/>
			}
			formikProps={ProductListEditFormProperties.formikProps}
			toClientDataFormat={ProductListEditFormProperties.toClientDataFormat}
			toServerDataFormat={ProductListEditFormProperties.toServerDataFormat}
			fetch={{ url: CIAPartyConfigApiUrls.GET }}
			update={{ url: CIAPartyConfigApiUrls.PUT }}
			id={id}
		/>
    )
    //* End of Function
}

export default ProductListEditForm